import React from "react";

// Official corporate logo (attached by the client). Use as-is, never modify.
export const CONVERGEN_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_convergen-insights/artifacts/2g03ggj0_convergen%20logo%20ok%202.jpeg";

// Square logo (medallion + wordmark) — used in nav, footer, login, hero, etc.
export default function ConvergenLogo({ size = 48, className = "", alt = "Convergen Consultoría" }) {
  return (
    <img
      src={CONVERGEN_LOGO_URL}
      alt={alt}
      style={{ height: size, width: "auto" }}
      className={`block ${className}`}
      draggable={false}
      data-testid="convergen-logo"
    />
  );
}
